import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="home-hero">
        <div className="hero-background">
          <div className="hero-overlay">
            <div className="hero-content">
              <h1 className="hero-title">In Every Stone</h1>
              <p className="hero-subtitle">a Love Story</p>
              <div className="hero-cta">
                <Link to="/gold-jewellery" className="cta-button primary">Explore Collection</Link>
                <Link to="/gold-rate" className="cta-button secondary">View Gold Rates</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Collections */}
      <section className="featured-section">
        <div className="container">
          <h2 className="section-title">Featured Collections</h2>
          <div className="collections-grid">
            <Link to="/gold-jewellery" className="collection-card">
              <div className="collection-image">
                <div className="placeholder-image">Gold Collection</div>
              </div>
              <h3>Gold Jewellery</h3>
              <p>Exquisite gold pieces crafted with precision and elegance</p>
            </Link>
            <Link to="/diamond-jewellery" className="collection-card">
              <div className="collection-image">
                <div className="placeholder-image">Diamond Collection</div>
              </div>
              <h3>Diamond Jewellery</h3>
              <p>Sparkling diamonds set in beautiful designs</p>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
